import {
  ChangeDetectionStrategy,
  Component,
  output,
  inject,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import {
  CheckboxWithLabelComponent,
  FormControlComponent,
  PrimengButtonDirective,
  PrimengInputTextDirective,
  PrimengPasswordDirective,
  validateInDepth,
} from '@web/shared/ui';
import { ButtonModule } from 'primeng/button';
import { SignInForm } from '../../models/sign-in-form';
import { CheckboxModule } from 'primeng/checkbox';
import { isBrowserContext } from '@web/utils';

type SignInFromGroup = FormGroup<{
  usernameOrEmail: FormControl<string>;
  password: FormControl<string>;
  rememberMe: FormControl<boolean>;
}>;

@Component({
  selector: 'app-sign-in-form',
  imports: [
    ButtonModule,
    FormControlComponent,
    InputTextModule,
    PasswordModule,
    PrimengButtonDirective,
    PrimengInputTextDirective,
    PrimengPasswordDirective,
    ReactiveFormsModule,
    CheckboxModule,
    CheckboxWithLabelComponent,
  ],
  templateUrl: './sign-in-form.component.html',
  styleUrl: './sign-in-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignInFormComponent {
  private readonly builder = inject(FormBuilder);

  public readonly submitClickEvent = output<SignInForm>();

  protected readonly form = this.buildForm();
  protected readonly isBrowserContext = isBrowserContext();

  public handleSubmitClick(): void {
    if (validateInDepth(this.form)) {
      this.submitClickEvent.emit(this.toData());
    }
  }

  private toData(): SignInForm {
    const data = this.form.getRawValue();

    return new SignInForm(data.usernameOrEmail, data.password, data.rememberMe);
  }

  private buildForm(): SignInFromGroup {
    return this.builder.group({
      usernameOrEmail: this.builder.nonNullable.control('', [
        Validators.required,
      ]),
      password: this.builder.nonNullable.control('', [Validators.required]),
      rememberMe: this.builder.nonNullable.control(false),
    });
  }
}
